import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../helpers/Constants';

const fetchCommentsCounterService = async (orderId, userEmail) => {
  try {
    return await axios.get(`/api/order/${orderId}/comment/viewed/${userEmail}`);
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? UNKNOWN_ERROR);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { fetchCommentsCounterService };
